module.exports = function (app) {
	app.controller('pages.account.member-profile', ['$scope', '$filter', '$timeout', 'sessionData', 'services', '$cookies', 'finder-logic2', 'session', 'coremetrics', 'brand',
		function ($scope, $filter, $timeout, sessionData, services, $cookies, finderLogic, session, coremetrics, brand) {

			
			$scope.isEditable = false;
			$scope.isDependent = false;
			$scope.cancelResult = false;
			$scope.shouldShowDOB = false;
			$scope.checkboxShow = false;
			$scope.formInputs = {};
			$scope.memberProfileDrawer = false;
            $scope.memberList =[];
            var initialDemoInfo={};


			var theProductList = finderLogic.portalSelectedPlanActiveProducts();


			var thisBrand = brand.current.sharedBrandCode.toLowerCase();

			if(thisBrand == 'hmbcbs' || 'hbs' || 'hmbcbsde'){
				$scope.hcrLink = '/chmptl/chm/jsp/categorydetail.do?oid=-21889&type=channel&parentId=-13548&programId=439888';
			} else if (thisBrand == 'ibccr' || 'ibcah'){
				$scope.hcrLink = '/chmptl/chm/jsp/categorydetail.do?oid=-21884&type=channel&parentId=-13548&programId=439888';
			} else {
				$scope.hcrLink = '/chmptl/chm/jsp/categorydetail.do?oid=-21888&type=channel&parentId=-13548&programId=439888';
			}

			$scope.hcrLinkCoremetrics = function(){
				coremetrics.elementTag('Make Changes to your coverage','MEMBER:ACCOUNT SETTINGS');
			}; 

			

			$scope.races1=[{label: 'American Indian or Alaska Native', value: 'American Indian or Alaska Native'},
				{label: 'Asian', value: 'Asian'},
				{label: 'Black or African American', value: 'Black or African American'},
				{label: 'Native Hawaiian/Other Pacific Islander', value: 'Native Hawaiian/Other Pacific Islander'},
				{label: 'White', value: 'White'},
				{label: 'Other', value: 'Other'},
				{label: 'Choose not to answer', value: 'Choose not to answer'} ];


			$scope.races2 =[{label: 'American Indian or Alaska Native', value: 'American Indian or Alaska Native'},
				{label: 'Asian', value: 'Asian'},
				{label: 'Black or African American', value: 'Black or African American'},
				{label: 'Native Hawaiian/Other Pacific Islander', value: 'Native Hawaiian/Other Pacific Islander'},
				{label: 'White', value: 'White'},
				{label: 'Other', value: 'Other'}];


			$scope.ethnicBg = [
				{label: 'Hispanic or Latino', value: 'Hispanic or Latino'},
				{label: 'Not Hispanic or Latino', value: 'Not Hispanic or Latino'},
				{label: 'Unknown', value: 'Unknown'},
				{label: 'Choose not to answer', value: 'Choose not to answer'}];


			$scope.primLanguage = [ {label: 'English', value: 'English'},
				{label: 'Spanish', value: 'Spanish'},
				{label: 'Other', value: 'Other'},
				{label: 'Choose not to answer', value: 'Choose not to answer'}  ];

			$scope.preferredLang =[{label: 'English', value: 'English'},
				{label: 'Spanish', value: 'Spanish'},
				{label: 'Other', value: 'Other'},
				{label: 'Choose not to answer', value: 'Choose not to answer'}];

			$scope.comfortLang =[{label: 'English', value: 'English'},
				{label: 'Spanish', value: 'Spanish'},
				{label: 'American Sign Language', value: 'American Sign Language'},
				{label: 'Other', value: 'Other'},
				{label: 'Choose not to answer', value: 'Choose not to answer'}];


			$scope.englishComfort =[{label: 'Very well', value: 'Very well'},
				{label: 'Well', value: 'Well'},
				{label: 'Not well', value: 'Not well'},
				{label: 'Not at all', value: 'Not at all'},
				{label: 'Choose not to answer', value: 'Choose not to answer'}];


			$scope.eduCompleted =[ {label: '8th grade or less', value: '8th grade or less'},
				{label: 'Some high school, but did not graduate', value: 'Some high school, but did not graduate'},
				{label: 'High school graduate or GED', value: 'High school graduate or GED'},
				{label: 'Some college or 2-year degree', value: 'Some college or 2-year degree'},
				{label: '4-year college graduate', value: '4-year college graduate'},
				{label: 'More than 4-year college degree', value: 'More than 4-year college degree'},
				{label: 'Choose not to answer', value: 'Choose not to answer'} ];


				//save the selections
				var saveBackend= function(resp){

					services.rbsmbl.demographicsInfo().saveDemographicInfo(resp).then(function(success){
						$scope.formSubmit = true;
					},function(error){
						console.log("Member Info not saved");
					});
					$scope.memberProfileForm.$setPristine();
				};

				//if checkbox is check, store same value for all dependents on list
				$scope.dependentSame = function(copyToAllUsers) {
					if (copyToAllUsers == true) {
						for (var i = 0; i < $scope.memberList.length; i++) {
							$scope.memberList[i].language.englishLangComfortablity = $scope.memberList[0].language.englishLangComfortablity;
							$scope.memberList[i].language.langComfortableSpeaking = $scope.memberList[0].language.langComfortableSpeaking;
							$scope.memberList[i].language.langSpokenAtHome = $scope.memberList[0].language.langSpokenAtHome;
							$scope.memberList[i].language.preferredWrittenLang = $scope.memberList[0].language.preferredWrittenLang;
							$scope.memberList[i].ethnicity.ethnicity = $scope.memberList[0].ethnicity.ethnicity;
							$scope.memberList[i].raceInfo.raceList  = $scope.memberList[i].raceInfo.raceList ? $scope.memberList[i].raceInfo.raceList : [];

							var race1 = $scope.memberList[0].raceInfo.raceList[0] ? $scope.memberList[0].raceInfo.raceList[0] : {};
							var race2 = $scope.memberList[0].raceInfo.raceList[1] ? $scope.memberList[0].raceInfo.raceList[1] : {};

							$scope.memberList[i].raceInfo.raceList[0] = $scope.memberList[i].raceInfo.raceList[0] ? $scope.memberList[0].raceInfo.raceList[0] : race1;
							$scope.memberList[i].raceInfo.raceList[1] = $scope.memberList[i].raceInfo.raceList[1] ? $scope.memberList[0].raceInfo.raceList[1] : race2;		
														
						}
						
					}
				};


				$scope.setCopyToFalse = function() {
					$scope.formInputs.copyToAllUsers = null;
				};

			//create member array
			var demographics;
			services.rbsmbl.demographicsInfo().getDemographicInfo().then(function (response) {
                demographics = response.data.payload.demographicInfo.demographicList;
                initialDemoInfo = angular.copy(demographics);

				if(demographics && demographics.length){
					$scope.memberList = demographics;

					populateModel($scope.memberList);}

			}, function (error) {
				console.log('error');
			});

            $scope.cancel = function() {
                //mark form pristine to hide cancel and save button
                $scope.memberProfileForm.$setPristine();
                //set form values with the initial data response from the service
                angular.copy(initialDemoInfo,$scope.memberList);
                // repopulate the form for drawers
                populateModel($scope.memberList);
                //set form submit back to false to override if it was set to true previously
                $scope.formSubmit = false;
				window.scrollTo(0,0);

            };

			var populateModel = function(memberList){

					//only show checkbox if memberList is > 1 and only show for first member in list
					if(memberList.length > 1){
						$scope.checkboxShow = true;
					}
					for(var k = 0; k < memberList.length; k++) {

						if (theProductList) {
							for (var p = 0; p < theProductList.length; p++) {
								var isHCR = theProductList[p].hcrProduct;
								//console.log("member-profile hcr product",theProductList[p].hcrProduct);
								if (isHCR == 'ON') {

									memberList[k].isEditable = false;
								}
								else {memberList[k].isEditable = true;}
							}
						}
						if (k == 0) {
							memberList[0].isOpen = true;
						} else {memberList[k].isOpen = false;}


					}

					$scope.shouldShowDOB = {};

					var duplicateNames = {};
					//check if member has same name and display birthday if so
					for (var i = 0; i < memberList.length; i++) {
						var member = memberList[i];

							
						for (var j = i+1; j<memberList.length; j++) {
							var otherMember = memberList[j];
							if (!$scope.shouldShowDOB[j]
								&& member.member.firstName.toUpperCase() === otherMember.member.firstName.toUpperCase()
								&& member.member.lastName.toUpperCase() === otherMember.member.lastName.toUpperCase()) {
								$scope.shouldShowDOB[j] = true;
								$scope.shouldShowDOB[i] = true;
							} 
						}
					}
			};






			$scope.save = function () {
				//console.log("saving info");
				var payload={ "demographicInfo":{
						"clientId":$cookies.get('mbrClientNumber'),
						"groupId":$cookies.get('mbrGroupNumber'),
						"demographicList":[]
                    }};

				for (var m = 0; m < $scope.memberList.length; m++){
                    var demoObject = {};
                    demoObject.member= $scope.memberList[m].member;
                    demoObject.raceInfo = $scope.memberList[m].raceInfo;
                    demoObject.ethnicity = $scope.memberList[m].ethnicity;
                    demoObject.language =$scope.memberList[m].language;
                    demoObject.education =$scope.memberList[m].education;
                    payload.demographicInfo.demographicList.push(demoObject);
				}
				saveBackend(payload);
                //var updateDemoInfo= {};
                var updateDemoInfo = payload.demographicInfo.demographicList;
                angular.copy(updateDemoInfo,initialDemoInfo);
			};


		}]);

	app.directive('raceObject', function($filter) {
		return {
			require: 'ngModel',
			link: function(scope, element, attrs, ngModel) {
				ngModel.$parsers.push(function(val) {
					return {
						race: val && val.race ? val.race : val,
						effectiveDate: $filter('date')(new Date(), 'MM/dd/yyyy')
					};
				});
				ngModel.$formatters.push(function(val) {
					return  val && val.race ? val.race : val;
				});
			}
		};
	});
};